// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"aR","backgroundimage":"bR","header":"cR","headerwrap":"eR","title":"fR","promomessage":"gR","upsellItem":"hR","upsellImg":"iR","helperText":"jR","upsellHeadline":"kR","price":"lR","upsellGross":"mR","upsellNet":"nR","upsellButton":"oR","nutritionfacts":"pR","nutritionimg":"qR","containerwhy":"rR","nutritionwrappwer":"sR","headlinewhy":"tR","boxwhy":"uR","textwhy":"vR","backbutton":"wR","drawercontainer":"xR","logoheader":"yR","textwrap":"zR","timer":"AR"};
    if(module.hot) {
      // 1714422957709
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  